import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import DownloadMaterials from "../components/download_materials";
import { selectDefaultReducer } from "../redux/default/selectors";

const DownloadMaterialsContainer = () => {
  const dispatch = useDispatch();
  const {
    downloadPaths,
    availableDownloadOptions,
    selectedProductIds,
    translations,
    customTranslations
  } = useSelector(selectDefaultReducer);

  const disabledDownloadAll =
    selectedProductIds.length === 0 || !availableDownloadOptions.all;
  const disabledDropup =
    selectedProductIds.length === 0 ||
    (!availableDownloadOptions.specs && !availableDownloadOptions.revit);
  const disabledDownload = disabledDropup;

  const downloadLabel1 =
    customTranslations.big_download_button_label_1 ||
    translations.download_all_materials;
  const downloadLabel2 =
    customTranslations.big_download_button_label_2 ||
    translations.download_materials_line_2;

  const onDownloadClick = () => dispatch(Action.downloadRequested());

  return (
    <DownloadMaterials
      disabledDownloadAll={disabledDownloadAll}
      disabledDropup={disabledDropup}
      disabledDownload={disabledDownload}
      selectedProductIds={selectedProductIds}
      downloadPaths={downloadPaths}
      availableDownloadOptions={availableDownloadOptions}
      downloadLabel1={downloadLabel1}
      downloadLabel2={downloadLabel2}
      translations={translations}
      customTranslations={customTranslations}
      onDownloadClick={onDownloadClick}
    />
  )
}

export default DownloadMaterialsContainer;